module.exports = __webpack_public_path__ + "static/media/step3@2x.0de4df33.png";